<template>
  <ul class="w-full">
    <li v-for="(item, index) in productFeatures" :key="item.name">
      <FeaturesCard :default-show="index === 0" :item-data="item" />
    </li>
  </ul>
</template>

<script setup lang="ts">
  import FeaturesCard from '@/components/Area/Products/FeaturesCard.vue';

  const productsStore = useProductsStore();
  const { productFeatures } = storeToRefs(productsStore);
</script>
